try {
    window.$ = window.jQuery = require('jquery');
    window.Swal = require("sweetalert2");
    window.select2 = require('select2');
} catch (e) {
}

require('bootstrap');
require('lazyload');
require('owl.carousel');

window.bootstrap = require('bootstrap');

import PhotoSwipeLightbox from './files/photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from './files/photoswipe/dist/photoswipe.esm.js';

import Alpine from 'alpinejs';

window.PhotoSwipeLightbox = PhotoSwipeLightbox;
window.PhotoSwipe = PhotoSwipe;

window.Alpine = Alpine;
Alpine.start();

/* =========================
   🔥 OWL HELPER (FIX CORE ISSUE)
========================= */
function initOwl(selector, config) {
    const $el = $(selector);

    if (!$el.length) return;

    if ($el.hasClass('owl-loaded')) {
        $el.trigger('destroy.owl.carousel');
        $el.removeClass('owl-loaded');
        $el.find('.owl-stage-outer').children().unwrap();
    }

    setTimeout(() => {
        $el.owlCarousel(config);
    }, 50);
}

/* =========================
   🧠 GLOBAL INIT
========================= */
$(function () {


    document.addEventListener('click', function (e) {

        if (e.target.closest('.close-category-modal')) {

            e.preventDefault();
            e.stopPropagation(); // 🔥 مهم‌ترین خط

            const button = e.target.closest('.close-category-modal');
            const modalId = button.getAttribute('data-modal');

            const el = document.getElementById(modalId);
            const modal = bootstrap.Modal.getOrCreateInstance(el);
            modal.hide();
        }
    });

    /* =========================
       PHOTO SWIPE
    ========================= */
    const gallerySite = new PhotoSwipeLightbox({
        gallery: '#gallerySite',
        children: 'a',
        pswpModule: PhotoSwipe
    });
    gallerySite.init();

    const galleryMobile = new PhotoSwipeLightbox({
        gallery: '#galleryMobile',
        children: 'a',
        pswpModule: PhotoSwipe
    });
    galleryMobile.init();

    /* =========================
       STATIC CAROUSELS (INIT ON LOAD)
    ========================= */

    initOwl('.product-scroll .owl-carousel', {
        stagePadding: 0,

        rtl: true,
        loop: true,
        lazyLoad: true,
        margin: 5,
        nav: true,
        dots: true,
        autoplay: false,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        responsive: {
            0: {items: 1.5, stagePadding: 5},
            400: {items: 1.5},
            768: {items: 3},
            1200: {items: 3}
        }
    });

    initOwl('.brand_slider .owl-carousel', {
        stagePadding: 50,
        rtl: true,
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        responsive: {
            0: {items: 1.5, stagePadding: 5},
            400: {items: 2},
            768: {items: 3},
            1200: {items: 3}
        }
    });

    initOwl('#featureProductSection .owl-carousel', {
        loop: false,
        rtl: true,
        autoWidth: true,
        margin: 0,
        nav: true,
        dots: false,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ]
    });

    initOwl('#owlCarouselFeatureProduct', {
        loop: false,
        rtl: true,
        autoWidth: true,
        margin: 0,
        nav: true,
        dots: false,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ]
    });

    /* =========================
       SCROLL HEADER LOGO
    ========================= */
    document.addEventListener("scroll", () => {
        let scrollY = window.scrollY;

        if (scrollY >= 100) {
            $('#sectionLogoHeader').addClass('hide-header-logo');
        } else {
            $('#sectionLogoHeader').removeClass('hide-header-logo');
        }
    });

    /* =========================
       SWEET ALERT
    ========================= */
    window.addEventListener('sweetAlert', function (e) {
        Swal.fire({
            title: e.detail.title,
            icon: e.detail.icon,
            toast: true,
            showConfirmButton: false,
            position: 'top-right',
            timer: 3000
        });
    });

    /* =========================
       TOOLTIP / POPUP FIX
    ========================= */
    window.addEventListener('tooltip', function () {
        $('[data-toggle="tooltip"]').tooltip();
    });

    window.addEventListener('closeModal', function (e) {
        $('#' + e.detail).modal('hide');
    });

    window.addEventListener('openModal', function (e) {
        $('#' + e.detail).modal('show');
        $('.card-fixed').addClass('stop-scrolling');
    });

    window.addEventListener('select2', function () {
        $('.js-example-basic-multiple').select2();
    });

    /* =========================
       SLIDER (FIXED - LIVEWIRE SAFE)
    ========================= */
    function bootSliderSafe() {
        const $slider = $('#slider-carousel .owl-carousel');

        if (!$slider.length) return;

        if ($slider.hasClass('owl-loaded')) {
            $slider.trigger('destroy.owl.carousel');
            $slider.removeClass('owl-loaded');
            $slider.find('.owl-stage-outer').children().unwrap();
        }

        requestAnimationFrame(() => {
            $slider.owlCarousel({
                loop: true,
                rtl: true,
                center: true,
                margin: 0,
                nav: true,
                dots: true,
                autoplayTimeout: 3500,
                autoplay: true,
                autoplayHoverPause: true,
                smartSpeed: 600, // 🔥 smooth transition (مهم)
                navText: [
                    "<i class='fas fa-chevron-right'></i>",
                    "<i class='fas fa-chevron-left'></i>"
                ],
                responsive: {
                    0: {items: 1}
                }
            });

            setTimeout(() => {
                $('#sliderLoading').fadeOut(200);
            }, 120);
        });
    }

    window.addEventListener('load', bootSliderSafe);
    document.addEventListener('DOMContentLoaded', bootSliderSafe);

    document.addEventListener('livewire:load', bootSliderSafe);
    document.addEventListener('livewire:update', bootSliderSafe);

    /* =========================
       FEATURE PRODUCT CAROUSEL EVENT
    ========================= */
    window.addEventListener('FeatureProductCarousel', function () {
        initOwl('#owlCarouselFeatureProduct', {
            loop: false,
            rtl: true,
            autoWidth: true,
            margin: 0,
            nav: true,
            dots: false,
            navText: [
                "<i class='fas fa-chevron-right'></i>",
                "<i class='fas fa-chevron-left'></i>"
            ]
        });
    });

    /* =========================
       CATEGORY CAROUSEL
    ========================= */
    window.addEventListener('carouselProductsCategoryJs', function () {
        initOwl('.carousel-products .owl-carousel', {
            loop: true,
            rtl: true,
            responsive: {
                0: {items: 2},
                768: {items: 4},
                1200: {items: 6}
            },
            margin: 5,
            autoWidth: true,
            lazyLoad: true,
            nav: true,
            dots: false,
            navText: [
                "<i class='fas fa-chevron-right ps-4'></i>",
                "<i class='fas fa-chevron-left pe-4'></i>"
            ]
        });
    });



    initOwl('.category-carousel', {
        rtl: true,
        loop: true,
        margin: 15,

        nav: false,
        dots: false,

        autoplay: true,
        autoplayTimeout: 3000, // هر 3 ثانیه
        autoplayHoverPause: true, // توقف هنگام هاور

        responsive: {
            0: {
                items: 1.3
            },
            768: {
                items: 3.2
            },
            1200: {
                items: 4
            }
        }
    });

});

/* =========================
   LIVEWIRE + TOOLTIP FIX
========================= */
$(document).ready(function () {

    $('[data-bs-toggle="tooltip"]').tooltip();
    $('[data-bs-toggle="popover"]').popover();

    if (typeof window.Livewire !== 'undefined') {
        window.Livewire.hook('message.processed', () => {
            $('[data-bs-toggle="tooltip"]').tooltip('dispose').tooltip();
            $('[data-bs-toggle="popover"]').popover('dispose').popover();
        });
    }

    /* =========================
       CART TOGGLE
    ========================= */
    $('.btn-cart-header').click(function (e) {
        e.preventDefault();
        $('.mini-cart').toggleClass('show');
    });

    /* =========================
       MINI CART CLOSE OUTSIDE CLICK
    ========================= */
    $(document).on('mousedown', function (event) {
        if (!$(event.target).closest('.mini-cart').length) {
            $('.mini-cart').removeClass('show');
        }
    });

    /* =========================
       FEATURE PRODUCT TABS
    ========================= */
    $(document).on("click", ".btn-tab-feature-product", function (e) {
        e.preventDefault();

        let tab = $(this).attr('data-tab');

        if ($(this).hasClass('active')) return;

        $('#featureProductSection').addClass('d-none');
        $('.btn-tab-feature-product').removeClass('active');
        $(this).addClass('active');

        $('#loadingFeatureProduct').removeClass('d-none');

        Livewire.emit('set-tab-feature-product', tab);
    });

    /* =========================
       SEARCH INPUTS (DEBOUNCE FIXED)
    ========================= */
    let timeoutID = null;

    function debounce(fn, value, loaderId, emitEvent) {
        clearTimeout(timeoutID);
        timeoutID = setTimeout(() => {
            $(loaderId).removeClass('d-none');
            Livewire.emit(emitEvent, value);
        }, 500);
    }

    $('#inputSearchHeader').keyup(function (e) {
        debounce(null, e.target.value, '#spinnerLoadingSearch', 'set-query-search-modal');
    });

    $('#inputSearchSidebar').keyup(function (e) {
        debounce(null, e.target.value, '#spinnerLoadingSearchSidebar', 'set-query-search-sidebar');
    });

    $('#inputSearchBrand').keyup(function (e) {
        debounce(null, e.target.value, '#preloadBrandList', 'set-query-search-brand');
    });

    $('#loginModal').on('shown.bs.modal', function () {
        const input = document.getElementById('mobile');

        if (input) {
            input.focus();
            input.select();
        }
    });


});
